import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { Feedback } from '../../../core/services/satisfaction.service';
import { TimezoneService } from '../../../core/services/timezone.service';
import { formatInTimeZone } from 'date-fns-tz';

@Component({
  selector: 'app-reply-history-modal',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './reply-history-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./reply-history-modal.component.scss']
})
export class ReplyHistoryModalComponent implements OnChanges {
  private timezone = inject(TimezoneService);

  @Input() show = false;
  @Input() feedback: Feedback | null = null;
  @Output() close = new EventEmitter<void>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes['show']) {
      if (this.show) {
        document.body.classList.add('modal-open');
      } else {
        document.body.classList.remove('modal-open');
      }
    }
  }

  formatDate(dateString: string): string {
    const date = new Date(dateString);
    const formatted = formatInTimeZone(date, this.timezone.getEstablishmentTimezone(), 'dd/MM/yyyy HH:mm');
    return `${formatted}${this.timezone.getTimezoneHint(date)}`;
  }

  onClose() {
    this.close.emit();
  }
}
